export enum MONITOR_SIDEBAR_MODULE {
  STUDENT_APPLICATION = 'STUDENT_APPLICATION',
  SUPERVISOR_NOMINATION = 'SUPERVISOR_NOMINATION',
  DORPGS_ASSESSMENT = 'DRC_ASSESSMENT',
  DRC_APPROVAL = 'DRC_APPROVAL',
  APPROVAL = 'APPROVAL',
  SCHOLARSHIP_EVALUATION = 'SCHOLARSHIP_EVALUATION',
  HOD_DOS_ASSESSMENT = 'HOD_DOS_ASSESSMENT',
  FRC_ASSESSMENT = 'FRC_ASSESSMENT',
  PANEL_SELECTION = 'PANEL_SELECTION',
  GS_DECISION = 'GS_DECISION',
  CONDITION_CHECK = 'CONDITION_CHECK',
  VISA_APPLICATION = 'VISA_APPLICATION',
  QUALIFICATION_CHECK = 'QUALIFICATION_CHECK',

  // only for supervisor team member use
  DECLARATION = 'DECLARATION',
}
